function About() {
    return (
        <div className="about">
            <h2>
                About
            </h2>
            <div>
                <a href="">
                    <i className="fa-solid fa-user" style={{
                        fontSize: "4rem"
                    }}>
                    </i>
                </a>
            </div>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti, ab, commodi voluptatem repudiandae dolores voluptatum in neque molestiae tempora sapiente possimus sunt minus suscipit laudantium voluptates quasi iusto non! Qui?
                <br /><br />
                Lorem ipsum dolor, sit amet consectetur adipisicing elit. Dicta, nesciunt corporis veniam repudiandae, consectetur dolor, nostrum sunt explicabo repellat odit eos soluta inventore. Exercitationem sunt officiis tempore sapiente at dolor.
            </p>
        </div>
    )
}

export default About